<template>
  <el-dialog
    v-dialog-drag
    :visible.sync="innerVisible"
    :title="`${isFcl?$t('Price.FCL'):$t('Price.LCL')}${$t('Message.FreightRateDetails')}`"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="price-dialog"
  >
    <template v-if="innerVisible">
      <div class="price-dialog-header">
        <div class="left">
          <h2 style="color:#ffce6b;">
            <span>{{ $t('Pricing.PriceType') }}：</span>
            <span>{{ freightType }}</span>
          </h2>
          <h2>
            <span>{{ priceAddon && isFcl ? getPortName(priceAddon.pol_a) : getPortName(price.pol) }}</span>
            <span style="margin:0 10px">————</span>
            <span>{{ getPortName(price.pod) }}</span>
          </h2>
          <h3>
            {{ $t('Price.FreightNumber') }}
            <span>{{ price.priceNo }}</span>
          </h3>
          <h3>
            {{ $t('Price.CabinStatus') }}
            <span>{{ getPriceStateLabel(price.priceState) }}</span>
          </h3>
        </div>
        <div class="right" :class="[price.trend === -1? 'green': '',price.trend === 1? 'red': '',]">
          <div v-if="isFcl" style="flex: 1;margin-right: 10px">
            <el-row type="flex" justify="end">
              <el-col v-if="hbRate.visible20" :span="5" :offset="4">{{ `20'${price.eqType}` }}</el-col>
              <el-col v-if="hbRate.visible40" :span="5">{{ `40'${price.eqType}` }}</el-col>
              <el-col v-if="hbRate.visibleHC" :span="5">40'HC</el-col>
              <el-col v-if="hbRate.visible45" :span="5">{{ `45'${price.eqType}` }}</el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-col :span="4">OF</el-col>
              <el-col v-if="hbRate.visible20" :span="5">{{ hbRate.lblOF20 }}</el-col>
              <el-col v-if="hbRate.visible40" :span="5">{{ hbRate.lblOF40 }}</el-col>
              <el-col v-if="hbRate.visibleHC" :span="5">{{ hbRate.lblOFHC }}</el-col>
              <el-col v-if="hbRate.visible45" :span="5">{{ hbRate.lblOF45 }}</el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-col :span="4">ALL IN</el-col>
              <el-col v-if="hbRate.visible20" :span="5">{{ hbRate.lblALLIN20 }}</el-col>
              <el-col v-if="hbRate.visible40" :span="5">{{ hbRate.lblALLIN40 }}</el-col>
              <el-col v-if="hbRate.visibleHC" :span="5">{{ hbRate.lblALLINHC }}</el-col>
              <el-col v-if="hbRate.visible45" :span="5">{{ hbRate.lblALLIN45 }}</el-col>
            </el-row>
            <p v-show="price.priceState === 4 || price.priceState === 5" class="red">{{ $t('Price.OurDumpingOfContainersOK') }}</p>
            <p>{{ $t('Price.NoteAdditionalChargesWithBackground') }}</p>
          </div>
          <div v-else style="flex: 1;margin-right: 10px">
            <el-row type="flex" justify="end">
              <el-col :span="5" :offset="4">TON</el-col>
              <el-col :span="5">CBM</el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-col :span="5">{{ $t('Pricing.ColoaderPrice') }}</el-col>
              <el-col :span="5">{{ getNumberLabel(price.oneWeightPrice) }}</el-col>
              <el-col :span="5">{{ getNumberLabel(price.oneVolumePrice) }}</el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-col :span="5">{{ $t('Pricing.CustomerPrice') }}</el-col>
              <el-col :span="5">{{ getNumberLabel(price.twoWeightPrice) }}</el-col>
              <el-col :span="5">{{ getNumberLabel(price.twoVolumePrice) }}</el-col>
            </el-row>
          </div>
          <el-button v-if="$checkPermission(['module_RemoteBooking']) && level>0" no="onRemoteBooking" style="width:80px;margin-bottom: 10px;" type="primary" @click="onRemoteBooking">{{ $t('Price.Booking') }}</el-button>
        </div>
      </div>
      <div class="price-dialog-content">
        <div class="description">
          <template>
            <div v-if="isFcl">
              <el-row>
                <el-col :span="1">{{ $t('Pricing.Carrier') }}</el-col>
                <el-col :span="4" class="blue">{{ getCarrierName(price.carrierScacCode,price.carrier) }}</el-col>
                <el-col :span="1">{{ $t('SeaExport.Vessel') }}</el-col>
                <el-col :span="3" class="blue">{{ price.vessel }}</el-col>
                <el-col :span="1">{{ $t('SeaExport.Voyage') }}</el-col>
                <el-col :span="3" class="blue">{{ price.voyageFlight }}</el-col>
                <el-col :span="1">ETD</el-col>
                <el-col :span="4" class="blue" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="getEtdName()">{{ getEtdName() }}</el-col>
                <el-col :span="1">ETA</el-col>
                <el-col :span="3" class="blue" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="getEtaName()">{{ getEtaName() }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="2">{{ $t('Pricing.BookingAgent') }}</el-col>
                <el-col :span="21" class="blue">{{ getBookingAgentName(price.bookingAgent) }}</el-col>
              </el-row>
            </div>
            <div v-else>
              <el-row>
                <el-col :span="2">{{ $t('Pricing.Carrier') }}</el-col>
                <el-col :span="21" class="blue">{{ getCarrierName(price.carrierScacCode,price.carrier) }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="2">{{ $t('Pricing.Source') }}</el-col>
                <el-col :span="21" class="blue">{{ getBookingAgentName(price.bookingAgent) }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="2">{{ $t('Pricing.ShareCarriers') }}</el-col>
                <el-col :span="21" class="blue">{{ getShareCarrierLabel(price.ShareCarriers) }}</el-col>
              </el-row>
            </div>
          </template>
          <template>
            <div v-if="isFcl">
              <div class="info">
                <span>{{ $t('Pricing.TradeLane') }}</span>
                <span class="blue">{{ getRegionName(price.pod) }}</span>
                <span>{{ $t('Pricing.Days') }}</span>
                <span class="blue">{{ price.days }}</span>
                <span>{{ $t('Pricing.DepartureDay') }}</span>
                <span class="blue">{{ isFrequency }}</span>
                <span>{{ $t('Pricing.BasicPort') }}</span>
                <span class="blue">{{ price.hasOwnProperty('PriceFclAddonEx')? getPortName(price.pol):null }}</span>
                <span>{{ $t('Pricing.Via') }}</span>
                <span class="blue">{{ getPortName(price.via) }}</span>
                <span>{{ $t('Pricing.Dock') }}</span>
                <span class="blue">{{ price.dock }}</span>
                <span>{{ $t('Pricing.VAT') }}</span>
                <span class="blue">{{ `${level===0 ? price.costVat : price.sellVat}%` }}</span>
                <span>{{ $t('Pricing.BeginDate') }}</span>
                <span class="blue">{{ `${$moment(price.beginDate).format('YYYY-MM-DD')}  -  ${$moment(price.endDate).format('YYYY-MM-DD')}` }}</span>
              </div>
              <div class="info">
                <span style="float: left;">{{ $t('Pricing.Remarks') }}</span>
                <textarea :rows="price.remarks ? '5' : '2'" no="remarks" :value="price.remarks" class="blueRemark" :style="'width:90%;overflow-y: visible;' + (price.remarks ? 'border-width: 1px;border-color: #ccc;' : 'border: none;resize: none;')" readonly />
              </div>
              <div class="info">
                <span>{{ $t('CargoMsg.Cargo_FreeUseContainer') }}</span>
                <span class="blue">{{ PriceUtils.dataGridColumnclnTimeFunc(price.freeTime) }}</span>
                <span>{{ $t('Pricing.priceNature') }}</span>
                <span class="blue">{{ ColumnUtils.showTypeLabelFunc(price.priceNature, PriceConstant.PRICE_NATURE) }}</span>
              </div>
            </div>
            <div v-else>
              <div class="info">
                <span>{{ $t('Pricing.DepartureDay') }}</span>
                <span class="blue">{{ isFrequency }}</span>
                <span>{{ $t('Pricing.ClosingDay') }}</span>
                <span class="blue">{{ price.closingDay }}</span>
                <span>{{ $t('Pricing.Days') }}</span>
                <span class="blue">{{ price.days }}</span>
                <span>{{ $t('Pricing.Via') }}</span>
                <span class="blue">{{ getPortName(price.via) }}</span>
                <span>{{ $t('Pricing.VAT') }}</span>
                <span class="blue">{{ `${level===0 ? price.costVat : price.sellVat}%` }}</span>
                <span>{{ $t('Pricing.PaymentTerm') }}</span>
                <span class="blue">{{ paymentLabelFunc(price.term) }}</span>
                <span>{{ $t('Pricing.CabinNature') }}</span>
                <span class="blue">{{ getShareLabel(price.share) }}</span>
                <span>{{ $t('Pricing.BeginDate') }}</span>
                <span class="blue">{{ `${$moment(price.beginDate).format('YYYY-MM-DD')}  -  ${$moment(price.endDate).format('YYYY-MM-DD')}` }}</span>
              </div>
              <div class="info">
                <span style="float: left;">{{ $t('Pricing.Remarks') }}</span>
                <textarea :rows="price.remarks ? '5' : '2'" no="remarks2" :value="price.remarks" class="blueRemark" :style="'width:90%; overflow-y: visible;' + (price.remarks ? 'border-width: 1px;border-color: #ccc;' : 'border: none;resize: none;')" readonly />
              </div>
              <div class="info">
                <span>{{ $t('Pricing.priceNature') }}</span>
                <span class="blue">{{ ColumnUtils.showTypeLabelFunc(price.priceNature, PriceConstant.PRICE_NATURE) }}</span>
              </div>
            </div>
          </template>
        </div>
        <template>
          <surcharge-fcl-data-grid
            v-if="isFcl"
            config-module="22010101"
            :row-data="surchargeFCLData"
            :show-approve="false"
            :show-cost="showCost"
            :price-no="price.priceNo"
            :show-selection="false"
            :show-cost-or-sell="true"
            :show-basic-info="false"
            :show-remark="false"
            :filter="filter"
            file-name="SurchargeFcl"
            :grid-options="surchargeFCLDataGrid.gridOptions"
          />
          <pol-charge-data-grid
            v-else
            config-module="22010102"
            :show-selection="false"
            :show-basic-info="false"
            :show-cost-or-sell="true"
            :show-cost="true"
            :row-data="PODChargeData"
            :grid-options="PODChargeDataGrid.gridOptions"
          />
        </template>
        <p>{{ $t('Pricing.WeightLimitInfo') }}</p>
        <weight-limit-data-grid
          config-module="22010103"
          :row-data="priceWeightLimitData"
          :grid-options="priceWeightLimitDataGrid.gridOptions"
        />
        <p>{{ $t('Pricing.ExtraInfo') }}</p>
        <fcl-extra-data-grid
          config-module="22010104"
          :show-check-box="false"
          :show-branch="false"
          :show-create="false"
          :show-modify="false"
          :row-data="priceFCLExtraData"
          :grid-options="priceFCLExtraDataGrid.gridOptions"
        />
        <template v-if="isFcl">
          <p>{{ $t('Pricing.ScheduleInfo') }}</p>
          <shipping-schedule-data-grid
            :show-check-box="false"
            config-module="22010105"
            :row-data="shippingScheduleData"
            :show-approve="false"
            :show-basic-info="false"
            :show-branch="false"
            :show-create="false"
            :show-modify="false"
            :grid-options="shippingScheduleDataGrid.gridOptions"
          />
        </template>
      </div>
    </template>
    <customer-popup
      :visible="customerPopup.visible"
      @ok="doRemoteBooking"
      @close="customerPopup.visible=false"
    />
  </el-dialog>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as NumberUtils from '@/utils/NumberUtils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { queryEffectiveSurchargeFCL } from '@/api/price/surchargeFcl'
import { queryEffectivePriceWeightLimit } from '@/api/price/priceWeightLimit'
import { queryOpenPriceFclExtra } from '@/api/price/priceFclExtra'
import { queryShippingSchedule } from '@/api/price/shippingSchedule'
import { queryEffectivePodCharge } from '@/api/price/podCharge'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import CustomerPopup from '@/views/cargo/v0/Price/components/customerPopup'
import { Job } from '@/class/model/booking/Job'
import SurchargeFclDataGrid from '@/views/cargo/v0/Price/SurchargeFCL/components/surchargeFclDataGrid'
import WeightLimitDataGrid from '@/views/cargo/v0/Price/components/grid/weightLimitDataGrid'
import FclExtraDataGrid from '@/views/cargo/v0/Price/components/grid/fclExtraDataGrid'
import ShippingScheduleDataGrid from '@/views/cargo/v0/Price/components/grid/shippingScheduleDataGrid'
import PODCharge from '@/views/cargo/v0/Price/PODCharge/index'
import PolChargeDataGrid from '@/views/cargo/v0/Price/components/grid/polChargeDataGrid'
import { getBusinessDocumentList } from '@/api/businessDocument'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import dateUtils from '@/utils/dateUtils'

export default {
  name: 'PriceDialog',
  components: {
    PolChargeDataGrid,
    PODCharge,
    ShippingScheduleDataGrid,
    FclExtraDataGrid, WeightLimitDataGrid, SurchargeFclDataGrid, CustomerPopup, CargoAgGrid },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    isFcl: {
      type: Boolean,
      default: () => true // true:整箱 false:拼箱
    },
    isDangerous: {
      type: Boolean,
      default: () => false
    },
    level: {
      type: Number,
      default: () => 99
    },
    etdDate: {
      type: String,
      default: () => ''
    },
    unNo: {
      type: String,
      default: () => ''
    },
    price: {
      type: Object,
      default: () => ({})
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    priceAddon: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      PriceUtils, PriceConstant, ColumnUtils,
      hbRate: {
        lblOF20: '',
        lblALLIN20: '',
        visible20: true,
        lblOF40: '',
        lblALLIN40: '',
        visible40: true,
        lblOFHC: '',
        lblALLINHC: '',
        visibleHC: true,
        lblOF45: '',
        lblALLIN45: '',
        visible45: true
      },
      showBasicInfo: true,
      showCostOrSell: true,
      targetCurrency: '',
      PODChargeData: [],
      surchargeFCLData: [],
      priceWeightLimitData: [],
      priceFCLExtraData: [],
      shippingScheduleData: [],
      surchargeFCLDataGrid: {
        gridOptions: {
          getRowStyle: function(params) {
            if (params.data.needAddToALLIN) {
              return { background: '#c0c0c0' }
            }
          }
        }
      },
      PODChargeDataGrid: {
        gridOptions: {}
      },
      priceWeightLimitDataGrid: {
        gridOptions: {}
      },
      priceFCLExtraDataGrid: {
        gridOptions: {}
      },
      shippingScheduleDataGrid: {
        gridOptions: {}
      },
      customerPopup: {
        visible: false
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    showCost() {
      return this.level === 0
    },
    freightType() {
      return CommonState.getNameByCode(PriceConstant.PRICE_ALL_TYPES, this.price.freightType)
    },
    isFrequency() {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.price['frequency' + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    },
    surchargeFCLColumnDefs() {
      const { showBasicInfo, showCostOrSell, showCost } = this
      return [
        {
          colId: 'pol',
          field: 'pol',
          headerName: this.$t('Pricing.POL'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'pod',
          field: 'pod',
          headerName: this.$t('Pricing.POD'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Pricing.TradeLane'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
          },
          hide: !showBasicInfo
        },
        {
          colId: 'carrier',
          field: 'carrier',
          headerName: this.$t('Pricing.Carrier'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'bookingAgent',
          field: 'bookingAgent',
          headerName: this.$t('Pricing.BookingAgent'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'eqType',
          field: 'eqType',
          headerName: this.$t('Pricing.EqType')
        },
        {
          colId: 'chargeType',
          field: 'chargeType',
          valueFormatter: PriceUtils.chargeTypeLabelFunc,
          headerName: this.$t('Pricing.ChargeType')
        },
        {
          colId: 'chargeScaleCode',
          field: 'chargeScaleCode',
          headerName: this.$t('Pricing.FeeName'),
          valueFormatter: (params) => {
            return PriceUtils.chargeScaleCodeLabelFunc(params, this.isZh)
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'unit',
          field: 'unit',
          headerName: this.$t('Pricing.ChargeUnit'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ChargeMeasure, 'code', params.value, this.isZh ? 'chineseName' : 'englishName')
          }
        },
        {
          colId: 'vat',
          field: 'vat',
          headerName: this.$t('Pricing.VatIncluded'),
          valueFormatter: this.boolLabelFunc
        },
        {
          colId: 'costVat',
          field: 'costVat',
          headerName: this.$t('Pricing.COST_VAT'),
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'cost20',
          field: 'cost20',
          headerName: '20\'(Cost)',
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'cost40',
          field: 'cost40',
          headerName: '40\'(Cost)',
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'costhc',
          field: 'costhc',
          headerName: '40\'HC(Cost)',
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'cost45',
          field: 'cost45',
          headerName: '45\'(Cost)',
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'costCasePrice',
          field: 'costCasePrice',
          headerName: this.$t('Pricing.UnitPrice') + '(Cost)',
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'sellVat',
          field: 'sellVat',
          headerName: this.$t('Pricing.SELL_VAT'),
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'sum20',
          field: 'sum20',
          headerName: '20\'' + (showCost ? '(Sell)' : ''),
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell
        },
        {
          colId: 'sum40',
          field: 'sum40',
          headerName: '40\'' + (showCost ? '(Sell)' : ''),
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell
        },
        {
          colId: 'sumhc',
          field: 'sumhc',
          headerName: '40\'HC' + (showCost ? '(Sell)' : ''),
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell
        },
        {
          colId: 'sum45',
          field: 'sum45',
          headerName: '45\'' + (showCost ? '(Sell)' : ''),
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell
        },
        {
          colId: 'casePrice',
          field: 'casePrice',
          headerName: this.$t('Pricing.UnitPrice') + (showCost ? '(Sell)' : ''),
          valueFormatter: this.numberColumnLabelFunc,
          hide: showCostOrSell
        },
        {
          colId: 'sellVat_2',
          field: 'sellVat',
          headerName: this.$t('Pricing.VAT'),
          valueFormatter: params => {
            return PriceUtils.vatLabelFunc2(params, this.showCost)
          },
          hide: !showCostOrSell
        },
        {
          colId: 'sum20_2',
          field: 'sum20',
          headerName: '20\'',
          valueFormatter: this.numberColumnLabelFunc2,
          hide: !showCostOrSell
        },
        {
          colId: 'sum40_2',
          field: 'sum40',
          headerName: '40\'',
          valueFormatter: this.numberColumnLabelFunc2,
          hide: !showCostOrSell
        },
        {
          colId: 'sumHC_2',
          field: 'sumhc',
          headerName: '40\'HC',
          valueFormatter: this.numberColumnLabelFunc2,
          hide: !showCostOrSell
        },
        {
          colId: 'sum45_2',
          field: 'sum45',
          headerName: '45\'',
          valueFormatter: this.numberColumnLabelFunc2,
          hide: !showCostOrSell
        },
        {
          colId: 'casePrice_2',
          field: 'casePrice',
          headerName: this.$t('Pricing.UnitPrice'),
          valueFormatter: this.numberColumnLabelFunc2,
          hide: !showCostOrSell
        },
        {
          colId: 'currency',
          field: 'currency',
          headerName: this.$t('Pricing.Currency'),
          hide: !showCostOrSell
        },
        {
          colId: 'payment',
          field: 'payment',
          headerName: this.$t('Pricing.PaymentTerm'),
          valueFormatter: this.paymentLabelFunc
        },
        {
          colId: 'remarks',
          field: 'remarks',
          headerName: this.$t('Pricing.Remarks'),
          hide: true
        },
        {
          colId: 'generateCharge',
          field: 'generateCharge',
          headerName: this.$t('Pricing.GenerateCharge'),
          valueFormatter: this.booleanColumnLabelFunc
        },
        {
          colId: 'dangerous',
          field: 'dangerous',
          headerName: this.$t('Pricing.Dangerous'),
          valueFormatter: this.booleanColumnLabelFunc
        },
        {
          colId: 'dangerousClass',
          field: 'dangerousClass',
          headerName: this.$t('Pricing.DangerousClass')
        },
        {
          colId: 'attachment',
          field: 'attachment',
          headerName: this.$t('Pricing.Attachment')
        }
      ]
    },
    priceWeightLimitColumnDefs() {
      return [
        {
          colId: 'pol',
          field: 'pol',
          headerName: this.$t('Pricing.POL'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'pod',
          field: 'pod',
          headerName: this.$t('Pricing.POD'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'via',
          field: 'via',
          headerName: this.$t('Pricing.Via'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'carrier',
          field: 'carrier',
          headerName: this.$t('Pricing.Carrier'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'isFrequency',
          field: 'isFrequency',
          headerName: this.$t('Pricing.DepartureDay')
        },
        {
          colId: 'eqType',
          field: 'eqType',
          headerName: this.$t('Pricing.EqType')
        },
        {
          colId: 'eqSize',
          field: 'eqSize',
          headerName: this.$t('Pricing.Measurement')
        },
        {
          colId: 'gradeMin',
          field: 'gradeMin',
          headerName: this.$t('Pricing.WeightRule'),
          valueFormatter: this.gradeMinLabelFunc
        },
        {
          colId: 'currency',
          field: 'currency',
          headerName: this.$t('Pricing.Currency')
        },
        {
          colId: 'amount',
          field: 'amount',
          headerName: this.$t('Pricing.Amount'),
          valueFormatter: this.numberColumnLabelFunc
        },
        {
          colId: 'remarks',
          field: 'remarks',
          headerName: this.$t('Pricing.Remarks')
        }
      ]
    },
    priceFCLExtraColumnDefs() {
      return [
        {
          colId: 'pol',
          field: 'pol',
          headerName: this.$t('Pricing.POL'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'pod',
          field: 'pod',
          headerName: this.$t('Pricing.POD'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'carrier',
          field: 'carrier',
          headerName: this.$t('Pricing.Carrier'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'isFrequency',
          field: 'isFrequency',
          headerName: this.$t('Pricing.DepartureDay')
        },
        {
          colId: 'lane',
          field: 'lane',
          headerName: this.$t('Pricing.Lane')
        },
        {
          colId: 'dockland',
          field: 'dockland',
          headerName: this.$t('Pricing.Dockland')
        },
        {
          colId: 'shareCarrier',
          field: 'shareCarrier',
          headerName: this.$t('Pricing.ShareCarriers'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'billType',
          field: 'billType',
          headerName: this.$t('Pricing.BillType')
        },
        {
          colId: 'shippingTerm',
          field: 'shippingTerm',
          headerName: this.$t('Pricing.ShippingClause')
        },
        {
          colId: 'seawayBill',
          field: 'seawayBill',
          headerName: 'SEAWAY BILL'
        }
      ]
    },
    shippingScheduleColumnDefs() {
      const { showBasicInfo } = this
      return [
        {
          colId: 'pol',
          field: 'pol',
          headerName: this.$t('Pricing.POL'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'pod',
          field: 'pod',
          headerName: this.$t('Pricing.POD'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'transferPort',
          field: 'transferPort',
          headerName: this.$t('Pricing.TransferPort'),
          tooltip: (val) => {
            return val
          },
          hide: !showBasicInfo
        },
        {
          colId: 'dockland',
          field: 'dockland',
          headerName: this.$t('Pricing.Dockland')
        },
        {
          colId: 'carrier',
          field: 'carrier',
          headerName: this.$t('Pricing.Carrier'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'lane',
          field: 'lane',
          headerName: this.$t('Pricing.Lane')
        },
        {
          colId: 'closingDay',
          field: 'closingDay',
          headerName: this.$t('Pricing.ClosingDay')
        },
        {
          colId: 'departureDay',
          field: 'departureDay',
          headerName: this.$t('Pricing.DepartureDay')
        },
        {
          colId: 'days',
          field: 'days',
          headerName: this.$t('Pricing.DaysColSea'),
          valueFormatter: (params) => {
            return params.value || ''
          }
        },
        {
          colId: 'remarks',
          field: 'remarks',
          headerName: this.$t('Pricing.Remarks')
        }
      ]
    },
    PODChargeColumnDefs() {
      const { showBasicInfo, showCostOrSell, showCost } = this
      return [
        {
          colId: 'bookingAgent',
          field: 'bookingAgent',
          headerName: this.$t('Pricing.Source'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'pol',
          field: 'pol',
          headerName: this.$t('Pricing.POL'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'pod',
          field: 'pod',
          headerName: this.$t('Pricing.POD'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          hide: !showBasicInfo
        },
        {
          colId: 'tradeLane',
          field: 'tradeLane',
          headerName: this.$t('Pricing.TradeLane'),
          valueFormatter: this.getRegionName,
          hide: !showBasicInfo
        },
        {
          colId: 'feeIndex',
          field: 'feeIndex',
          headerName: this.$t('Pricing.FeeIndex')
        },
        {
          colId: 'chargeType',
          field: 'chargeType',
          valueFormatter: PriceUtils.chargeTypeLabelFunc,
          headerName: this.$t('Pricing.ChargeType')
        },
        {
          colId: 'chargeScaleCode',
          field: 'chargeScaleCode',
          headerName: this.$t('Pricing.FeeName'),
          valueFormatter: (params) => {
            return PriceUtils.chargeScaleCodeLabelFunc(params, this.isZh)
          },
          tooltip: (params) => {
            return params.valueFormatted
          }
        },
        {
          colId: 'unit',
          field: 'unit',
          headerName: this.$t('Pricing.ChargeUnit'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ChargeMeasure, 'code', params.value, this.isZh ? 'chineseName' : 'englishName')
          }
        },
        {
          colId: 'currency',
          field: 'currency',
          headerName: this.$t('Pricing.Currency')
        },
        {
          colId: 'vat',
          field: 'vat',
          headerName: this.$t('Pricing.VatIncluded'),
          valueFormatter: this.boolLabelFunc
        },
        {
          colId: 'coloaderMin',
          field: 'coloaderMin',
          headerName: this.$t('Pricing.ColoaderMin'),
          valueFormatter: this.numberColumnLabelFunc
        },
        {
          colId: 'coloaderRate',
          field: 'coloaderRate',
          headerName: this.$t('Pricing.ColoaderRate'),
          valueFormatter: this.numberColumnLabelFunc
        },
        {
          colId: 'customerMin',
          field: 'customerMin',
          headerName: this.$t('Pricing.CustomerMin'),
          valueFormatter: this.numberColumnLabelFunc
        },
        {
          colId: 'customerRate',
          field: 'customerRate',
          headerName: this.$t('Pricing.CustomerRate'),
          valueFormatter: this.numberColumnLabelFunc
        },
        {
          colId: 'costVat',
          field: 'costVat',
          headerName: this.$t('Pricing.COST_VAT'),
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'sellVat',
          field: 'sellVat',
          headerName: this.$t('Pricing.SELL_VAT'),
          hide: showCostOrSell || !showCost
        },
        {
          colId: 'sellVat_2',
          field: 'sellVat',
          headerName: this.$t('Pricing.VAT'),
          valueFormatter: params => {
            return PriceUtils.vatLabelFunc2(params, this.showCost)
          },
          hide: !showCostOrSell
        }
      ]
    },
    isZh() {
      return this.$store.getters.language
    }
  },
  watch: {
    price() {
      if (this.isFcl) {
        this.getSurchargeFCLData()
        this.getShippingScheduleData()
      } else {
        this.getPODChargeData()
      }
      this.getPriceWeightLimitData()
      this.getPriceFCLExtraData()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      if (this.isFcl) {
        this.getSurchargeFCLData()
        this.getShippingScheduleData()
      } else {
        this.getPODChargeData()
      }
      this.getPriceWeightLimitData()
      this.getPriceFCLExtraData()
    },
    initParam() {
      const { price, surchargeFCLData, hbRate, level } = this
      const priceFieldMap = PriceUtils.priceFieldMap
      let sf = null
      let allIn = 0
      // const office = this.$store.getters.currentOffice
      // let p = this.getNumberLabel(office.officeId === price.branchId ? price[priceFieldMap[level] + '20'] : price['three20'])
      let p = this.getNumberLabel(price[priceFieldMap[level] + '20'])
      if (price && price.hasOwnProperty('PriceFclAddonEx')) {
        p = this.getNumberLabel(Number(p) + price['sum20_a'] + price['sum20_b'])
      }
      const messages = []
      const messageMap = {}
      let exchangeRate
      let rate
      if (p !== '') {
        hbRate.lblOF20 = p
        if (surchargeFCLData && surchargeFCLData.length) {
          // allIn = office.officeId === price.branchId ? price[priceFieldMap[level] + '20'] : price['three20']
          allIn = price[priceFieldMap[level] + '20']
          if (price && price.hasOwnProperty('PriceFclAddonEx')) {
            allIn = allIn + price['sum20_a'] + price['sum20_b']
          }
          for (sf of surchargeFCLData) {
            if (sf.chargeType === 'S') {
              rate = level === 0 ? sf.cost20 : sf.sum20
              if (rate !== PriceConstant.NIL) {
                if (sf.currency === price.currency) {
                  allIn += rate
                } else {
                  exchangeRate = PriceUtils.getForeignExchangeRate(sf.currency, price.currency)
                  if (exchangeRate > 0) {
                    allIn += rate / exchangeRate
                  } else {
                    if (!messageMap.hasOwnProperty(sf.currency)) {
                      messages.push(sf.currency)
                      messageMap[sf.currency] = 1
                    }
                  }
                }
                sf.needAddToALLIN = true
              }
            }
          }
          hbRate.lblALLIN20 = this.getCeilNumberLabel(allIn)
        } else {
          hbRate.lblALLIN20 = p
        }
      }
      hbRate.visible20 = !!p
      // p = this.getNumberLabel(office.officeId === price.branchId ? price[priceFieldMap[level] + '40'] : price['three40'])
      p = this.getNumberLabel(price[priceFieldMap[level] + '40'])
      if (price && Object(price).toString().indexOf('PriceFclAddonEx') > -1) {
        p = this.getNumberLabel(Number(p) + price['sum40_a'] + price['sum40_b'])
      }
      if (p !== '') {
        hbRate.lblOF40 = p
        if (surchargeFCLData && surchargeFCLData.length) {
          // allIn = office.officeId === price.branchId ? price[priceFieldMap[level] + '40'] : price['three40']
          allIn = price[priceFieldMap[level] + '40']
          if (price && price.hasOwnProperty('PriceFclAddonEx')) {
            allIn = allIn + price['sum40_a'] + price['sum40_b']
          }
          for (sf of surchargeFCLData) {
            if (sf.chargeType === 'S') {
              rate = level === 0 ? sf.cost40 : sf.sum40
              if (rate !== PriceConstant.NIL) {
                if (sf.currency === price.currency) {
                  allIn += rate
                } else {
                  exchangeRate = PriceUtils.getForeignExchangeRate(sf.currency, price.currency)
                  if (exchangeRate > 0) {
                    allIn += rate / exchangeRate
                  } else {
                    if (!messageMap.hasOwnProperty(sf.currency)) {
                      messages.push(sf.currency)
                      messageMap[sf.currency] = 1
                    }
                  }
                }
                sf.needAddToALLIN = true
              }
            }
          }
          hbRate.lblALLIN40 = this.getCeilNumberLabel(allIn)
        } else {
          hbRate.lblALLIN40 = p
        }
      }
      hbRate.visible40 = !!p
      // p = this.getNumberLabel(office.officeId === price.branchId ? price[priceFieldMap[level] + 'hc'] : price['threehc'])
      p = this.getNumberLabel(price[priceFieldMap[level] + 'hc'])
      if (price && Object(price).toString().indexOf('PriceFclAddonEx') > -1) {
        p = this.getNumberLabel(Number(p) + price['sumHC_a'] + price['sumHC_b'])
      }
      if (p !== '') {
        hbRate.lblOFHC = p
        if (surchargeFCLData && surchargeFCLData.length) {
          // allIn = office.officeId === price.branchId ? price[priceFieldMap[level] + 'hc'] : price['threehc']
          allIn = price[priceFieldMap[level] + 'hc']
          if (price && price.hasOwnProperty('PriceFclAddonEx')) {
            allIn = allIn + price['sumHC_a'] + price['sumHC_b']
          }
          for (sf of surchargeFCLData) {
            if (sf.chargeType === 'S') {
              rate = level === 0 ? sf.costhc : sf.sumhc
              if (rate !== PriceConstant.NIL) {
                if (sf.sumhc !== PriceConstant.NIL) {
                  if (sf.currency === price.currency) {
                    allIn += rate
                  } else {
                    exchangeRate = PriceUtils.getForeignExchangeRate(sf.currency, price.currency)
                    if (exchangeRate > 0) {
                      allIn += rate / exchangeRate
                    } else {
                      if (!messageMap.hasOwnProperty(sf.currency)) {
                        messages.push(sf.currency)
                        messageMap[sf.currency] = 1
                      }
                    }
                  }
                  sf.needAddToALLIN = true
                }
              }
            }
          }
          hbRate.lblALLINHC = this.getCeilNumberLabel(allIn)
        } else {
          hbRate.lblALLINHC = p
        }
      }
      hbRate.visibleHC = !!p
      // p = this.getNumberLabel(office.officeId === price.branchId ? price[priceFieldMap[level] + '45'] : price['three45'])
      p = this.getNumberLabel(price[priceFieldMap[level] + '45'])
      if (price && Object(price).toString().indexOf('PriceFclAddonEx') > -1) {
        p = this.getNumberLabel(Number(p) + price['sum45_a'] + price['sum45_b'])
      }
      if (p !== '') {
        hbRate.lblOF45 = p
        if (surchargeFCLData && surchargeFCLData.length) {
          // allIn = office.officeId === price.branchId ? price[priceFieldMap[level] + '45'] : price['three45']
          allIn = price[priceFieldMap[level] + '45']
          if (price && Object(price).toString().indexOf('PriceFclAddonEx') > -1) {
            allIn = allIn + price['sum45_a'] + price['sum45_b']
          }
          for (sf of surchargeFCLData) {
            if (sf.chargeType === 'S') {
              rate = level === 0 ? sf.cost45 : sf.sum45
              if (rate !== PriceConstant.NIL) {
                if (sf.sum45 !== PriceConstant.NIL) {
                  if (sf.currency === price.currency) {
                    allIn += rate
                  } else {
                    exchangeRate = PriceUtils.getForeignExchangeRate(sf.currency, price.currency)
                    if (exchangeRate > 0) {
                      allIn += rate / exchangeRate
                    } else {
                      if (!messageMap.hasOwnProperty(sf.currency)) {
                        messages.push(sf.currency)
                        messageMap[sf.currency] = 1
                      }
                    }
                  }
                  sf.needAddToALLIN = true
                }
              }
            }
          }
          hbRate.lblALLIN45 = this.getCeilNumberLabel(allIn)
        } else {
          hbRate.lblALLIN45 = p
        }
      }
      hbRate.visible45 = !!p
      if (messages.length > 0) {
        const msg = this.$t('Pricing.NoExchangeRate')
        this.$message.warn(StrUtils.substitute(msg, messages.join(',')))
      }
    },
    getSurchargeFCLData() {
      const { pol, pod, via, carrier, bookingAgent, beginDate, endDate, freightType, eqType } = this.price
      const payload = {
        pol, pod, via, carrier, bookingAgent, beginDate, endDate, direct: !via, freightType, eqType, unNo: this.unNo, dangerous: this.isDangerous, fclPrice: true
      }
      const region = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.price.pod, 'region')
      if (!StrUtils.isEmpty(region)) {
        payload.region = region
      }
      queryEffectiveSurchargeFCL(payload).then(res => {
        this.surchargeFCLData = res.data
        this.initParam()
        this.initFile(this.surchargeFCLData)
      })
    },
    initFile(data) {
      if (!data || data.length === 0) {
        return
      }
      const businessIds = []
      for (const item of data) {
        businessIds.push(item.uuid)
      }
      getBusinessDocumentList({ businessIds: businessIds.join(',') }).then(res => {
        const result = res.data
        if (result && result.length > 0) {
          const docMap = {}
          for (const doc of result) {
            if (!docMap.hasOwnProperty(doc.businessId)) {
              docMap[doc.businessId] = []
            }
            docMap[doc.businessId].push(doc)
          }
          for (const fcl of data) {
            fcl['businessDocuments'] = docMap[fcl.uuid]
          }
        }
      })
    },
    getPODChargeData() {
      const { price, isDangerous, unNo } = this
      const { pol, pod, rod, bookingAgent, beginDate, endDate } = price
      const params = { pol, pod, rod, bookingAgent, beginDate, endDate }
      queryEffectivePodCharge(params).then(res => {
        this.PODChargeData = res.data
      })
    },
    getPriceWeightLimitData() {
      const { price, isFrequency } = this
      const { pol, pod, via, carrier, eqType, beginDate, endDate } = price
      const params = { pol, pod, via, carriers: `${carrier}`, eqType, beginDate, endDate }
      params.tenantId = this.$store.getters.tenantId
      params.frequency = isFrequency.split('/').map(i => `frequency${i}`)
      queryEffectivePriceWeightLimit(params).then(res => {
        this.priceWeightLimitData = res.data
      })
    },
    getPriceFCLExtraData() {
      const { price, isFrequency } = this
      const { pol, pod, via, carrier, beginDate, endDate } = price
      const params = { pol, pod, via, carriers: `${carrier}`, beginDate, endDate }
      params.tenantId = this.$store.getters.tenantId
      params.frequency = isFrequency.split('/').map(i => `frequency${i}`)
      queryOpenPriceFclExtra(params).then(res => {
        this.priceFCLExtraData = res.data
      })
    },
    getShippingScheduleData() {
      const { price } = this
      const { pol, pod, lane, carrier, beginDate, endDate, tenantId } = price
      const params = { pol, pod, lane, carrier, beginDate, endDate }
      if (tenantId > 0 && tenantId !== this.$store.getters.tenantId) {
        params.tenantId = this.$store.getters.tenantId
      }
      queryShippingSchedule(params).then(res => {
        this.shippingScheduleData = res.data
      })
    },
    getPriceStateLabel(priceState) {
      switch (priceState) {
        case 0:
          return this.$t('Pricing.PriceState_Common')
        case 1:
          return this.$t('Pricing.PriceState_Suspend')
        case 2:
          return this.$t('Pricing.PriceState_Reject')
        case 3:
          return this.$t('Pricing.PriceState_Inquiry')
        case 4:
          return this.$t('Pricing.PriceState_Lack')
        case 5:
          return this.$t('Pricing.PriceState_Overbooked')
      }
      return this.$t('Pricing.PriceState_Common')
    },
    getNumberLabel(num) {
      if (num === 0.0) return '0'
      if (!isNaN(num)) {
        if (num === PriceConstant.NIL) return ''
        if (num < 0) return `(${NumberUtils.roundHalfUp(-num)})`
        return NumberUtils.roundHalfUp(num).toFixed(2)
      }
      return ''
    },
    getCeilNumberLabel(num) {
      if (num === 0.0) return '0'
      if (!isNaN(num)) {
        if (num === PriceConstant.NIL) return ''
        if (num < 0) return `(${NumberUtils.roundHalfUp(-Math.ceil(num))})`
        return NumberUtils.roundHalfUp(Math.ceil(num)).toFixed(2)
      }
      return ''
    },
    getPortName(code) {
      const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', code)
      return port ? port.englishName : code
    },
    getRegionName(code) {
      const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', code)
      if (port) {
        const rg = getObjectByCache(TYPE_NAMES.basic_data_Region, 'code', port.region)
        return rg ? rg.name : port.region
      }
      return ''
    },
    getCompanyByScac(scac) {
      const companies = getFilterCacheList(basicCacheKeys.basic_data_Company)
      if (companies) {
        for (const company of companies) {
          if (scac != null && scac !== '' && scac === company.scac) {
            return company
          }
        }
      }
      return null
    },
    getCompanyByIdSync(cmpIdx) {
      if (!cmpIdx || cmpIdx <= 0) return null
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      return company || null
    },
    getCarrierName(carrierScacCode, carrier) {
      let company = null
      if (!StrUtils.isEmpty(carrierScacCode)) {
        company = this.getCompanyByScac(this.price.carrierScacCode)
      } else {
        company = this.getCompanyByIdSync(carrier)
      }
      if (company) {
        return (this.isZh ? company.chineseName : company.englishName) || company.shortName
      }
      return ''
    },
    getShareCarrierLabel(shareCarrier) {
      if (shareCarrier) {
        const cpys = shareCarrier.split(',')
        const result = cpys.map(cpy => {
          if (cpy) {
            return this.getCompanyByIdSync(cpy)
          }
        })
        return result.join(',')
      }
      return ''
    },
    getShareLabel(share) {
      if (share === 'SELF') return this.$t('Pricing.Self')
      if (share === 'SHARE') return this.$t('Pricing.Share')
      return ''
    },
    getBookingAgentName(bookingAgent) {
      const { price, isZh } = this
      let company = null
      if (this.$store.getters.tenantId === price.tenantId) {
        if (!StrUtils.isEmpty(price.sourcePriceUuid)) {
          return this.tenantUtil.getTenantNameById(price.bookingAgent)
        } else {
          company = this.getCompanyByIdSync(bookingAgent)
        }
      } else {
        return this.tenantUtil.getTenantNameById(price.tenantId)
      }
      if (company) {
        return (isZh ? company.chineseName : company.englishName) || company.shortName
      }
      return ''
    },
    // 新建委托
    onRemoteBooking() {
      this.customerPopup.visible = true
    },
    doRemoteBooking(customerId) {
      const job = new Job().fillDefaultValue().getData()
      job.customerId = customerId
      job.priceNo = this.price.priceNo
      job.priceTier = this.level
      // 免柜租期
      job.tmpFreeTime = this.price.freeTime
      // 航线代码
      job.tmpVesselLineCode = this.price.lane
      // 装货港
      job.loadingPortCode = this.price.pol
      job.sales = this.$store.getters.userId
      // 卸货港
      job.dischargingPortCode = this.price.pod
      job.customerId = customerId
      job.carrierId = this.price.carrier
      job.bookingAgent = this.price.bookingAgent// 当前用户是电商，调取真实订舱代理
      job.containerLoadType2 = 'FCL'
      job.priceSource = PriceConstant.PRICE_SOURCE_BOOKING
      const isFrequency = PriceUtils.isFrequency(this.price)
      if (isFrequency.length === 1) {
        const beginDate = new Date(this.price.beginDate)
        const endDate = new Date(this.price.endDate)
        let today = new Date()
        today = new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())// 去除时分秒

        if (endDate.getTime() - today.getTime() <= 0) {
          this.$message.warning('此运价已过期!')
          return
        }
        const startDate = today.getTime() - beginDate.getTime() > 0 ? today : beginDate
        const frequency = parseInt(isFrequency)
        const weekDay = startDate.getDay() === 0 ? 7 : startDate.getDay()
        if (frequency === weekDay) {
          job.ETD = startDate
        } else {
          let etd = null
          if (frequency > weekDay) {
            etd = new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() + frequency - weekDay + 1)
          } else {
            etd = new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() + frequency - weekDay + 7 + 1)
          }
          if (etd.getTime() <= endDate.getTime()) {
            job.ETD = etd
          } else {
            this.$message.warning(this.$t('Price.NoFreightThatMeetsParty'))
            return
          }
        }
      }
      this.$router.push({
        name: 'RemoteBooking',
        params: {
          view: 'detail',
          action: 'add',
          job
        }
      })
      this.customerPopup.visible = false
      this.innerVisible = false
    },
    paymentLabelFunc(params) {
      const value = typeof params === 'object' ? params.value : params
      if (!value) return ''
      switch (value) {
        case 'P':
          return this.$t('Pricing.Prepaid')
        case 'C':
          return this.$t('Pricing.Collect')
        case 'B':
          return this.$t('Pricing.Both')
      }
      return ''
    },
    boolLabelFunc(params) {
      const { value } = params
      return value ? 'Y' : 'N'
    },
    booleanColumnLabelFunc(params) {
      const { value } = params
      if (!value) return ''
      if (value) {
        return '√'
      } else {
        return ''
      }
    },
    numberColumnLabelFunc(params) {
      const { value, data } = params
      const { targetCurrency } = this
      if (value === 0) return 0
      if (!isNaN(value)) {
        if (value === PriceConstant.NIL) return ''
        if (targetCurrency && data['currency'] !== targetCurrency) {
          const rate = RateUtil.getForeignExchangeRateSafely(data['currency'], targetCurrency, new Date(), 0)
          if (rate > 0) {
            const price = value / rate
            if (price < 0) return `(${NumberUtils.roundHalfUp(-price)})`
            return NumberUtils.roundHalfUp(price).toFixed(2)
          }
        } else {
          if (value < 0) return `(${NumberUtils.roundHalfUp(-value)})`
        }
        return NumberUtils.roundHalfUp(value).toFixed(2)
      }
      return ''
    },
    numberColumnLabelFunc2(params) {
      const { data, colDef } = params
      const { targetCurrency, showCost } = this
      let { field } = colDef
      if (showCost) {
        if (field !== 'casePrice') {
          field = field.replace('sum', 'cost')
        } else {
          field = 'costCasePrice'
        }
      }
      const value = data[field]
      if (value === 0) return 0
      if (!isNaN(value)) {
        if (value === PriceConstant.NIL) return ''
        if (targetCurrency && data['currency'] !== targetCurrency) {
          const rate = RateUtil.getForeignExchangeRateSafely(data['currency'], targetCurrency, new Date(), 0)
          if (rate > 0) {
            const price = value / rate
            if (price < 0) return `(${NumberUtils.roundHalfUp(-price)})`
            return NumberUtils.roundHalfUp(price).toFixed(2)
          }
        } else {
          if (value < 0) return `(${NumberUtils.roundHalfUp(-value)})`
        }
        return NumberUtils.roundHalfUp(value).toFixed(2)
      }
      return ''
    },
    gradeMinLabelFunc(params) {
      const { data, value } = params
      if (!value) return ''
      if (data.gradeMin !== PriceConstant.NIL) {
        if (data.gradeMax !== PriceConstant.NIL) {
          return data.gradeMin + '-' + data.gradeMax
        } else {
          return '＞' + data.gradeMin
        }
      } else {
        if (data.gradeMax !== PriceConstant.NIL) {
          return '≤' + data.gradeMax
        }
      }
      return ''
    },
    getEtdName() {
      // 如果是传统运价，则返回ETD列表
      const { freightType, beginDate, endDate, frequency8, etd } = this.price
      if (freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code) {
        const etds = dateUtils.getDatesByWeekdaysFormat(beginDate, endDate, frequency8)
        return etds.join(',')
      }
      // 如果是SPOT运价，则返回电商ETD
      if (freightType === PriceConstant.PRICE_TYPE_SPOT.code) {
        return ColumnUtils.dateLabelFunc(etd)
      }
    },
    getEtaName() {
      // 如果是传统运价，则返回ETD列表
      const { freightType, beginDate, endDate, frequency8, eta, days } = this.price
      if (freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code) {
        const etds = dateUtils.getDatesByWeekdaysFormat(beginDate, endDate, frequency8)
        // 遍历所有日期，加航程
        if (!etds || etds.length === 0) {
          return ''
        }
        const etas = []
        for (const etdDate of etds) {
          etas.push(dateUtils.formatDate(dateUtils.addDays(etdDate, Number(days)), 'yyyy-MM-dd'))
        }
        return etas.join(',')
      }
      // 如果是SPOT运价，则返回电商ETD
      if (freightType === PriceConstant.PRICE_TYPE_SPOT.code) {
        return ColumnUtils.dateLabelFunc(eta)
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.price-dialog{
  p{
    margin-top:10px;
    margin-bottom:10px;
  }
  &-header {
    display: flex;
    padding: 0 10px;
    .left{
      width: 55%;
      h2 {
        margin-top:0;
        margin-bottom:10px;
        color: $--color-primary-light-1;
        span{
          font-size: 1.5em!important;}
      }
      h3 {
        color: $--color-warning;
        margin-bottom: 5px;
        span{
          font-size: 1.17em!important;
        }
      }
    };
    .right{
      flex: 1;
      display: flex;
      text-align: right;
      .el-row{
        margin-bottom: 5px;
      }
      .el-col {
        font-size: 14px;
        font-weight: bold;
        text-align: right;
        color: $--color-primary-light-1;
      }
      &.green{
        .el-col{
          color: $--color-success;
        }
      }
      &.red{
        .el-col {
          color: $--color-danger;
        }
      }
      p{
        font-size: 12px;;
        color: $--color-primary-light-1;
      }
    };
  }
  &-content{
    height: 400px;
    border-top:1px solid $--border-color-base;
    overflow-y: scroll;
    .description{
      padding:10px;
      font-size: 12px;
      .el-row{
        margin-bottom: 10px;
      }
      .blue {
        color: $--color-primary-light-1;
      }
      .blueRemark {
         color: $--color-primary-light-1;
         outline: none; /* 清除浏览器默认的选中轮廓，避免干扰 */
       }
      .blueRemark:focus {
        border-color: #ccc; /* 选中时保持浅灰色边框 */
      }
      .info {
        margin-top: 10px;
        span {
          margin-right: 10px;
        }
      }
    }
  }
}

</style>
